import { useContext } from "react";
import checkoutContext from "../../../../checkout-context";
import { Address, CompanyDetails } from "../../types/Types";
import { InvoiceOptionCard } from "../../invoice-options/invoice-option-slider/invoice-option-card/InvoiceOptionCard";

type InvoiceOptionSelectorProps = {
  options: (Address | CompanyDetails)[];
  selectedOptionIndex: number | null;
  onOptionSelect: (index: number) => void;
  onEdit: () => void;
  onAdd: () => void;
};

export function InvoiceOptionSelector({
  options,
  selectedOptionIndex,
  onOptionSelect,
  onEdit,
  onAdd,
}: InvoiceOptionSelectorProps) {
  const { textsMapping } = useContext(checkoutContext);

  return (
    <div className="invoice-option-selector">
      {options.map((option, index) => (
        <InvoiceOptionCard
          key={index}
          isActive={selectedOptionIndex === index}
          option={option}
          onClick={() => onOptionSelect(index)}
          onEdit={onEdit}
        />
      ))}
      <button
        type="button"
        className="invoice-option-selector__add-address"
        onClick={onAdd}
      >
        {textsMapping.addInvoiceOptionText}
      </button>
    </div>
  );
}
